export const setupConsentChangedListener = consentChangedHandler => {
  window.OneTrust.OnConsentChanged(consentChangedHandler);
};
